import { Tooltip } from '@/components/primitives/Tooltip'
import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'

export function StatusField() {
  const texts = useTexts()

  return (
    <form.Checkbox
      label={
        <Tooltip title={texts.requiredTooltip} placement="bottom">
          <>{texts.status}</>
        </Tooltip>
      }
      name="includeStatusChecked"
      testId="driver-assistance-form-status-field"
      disabled={true}
      validateOn="blur change"
    />
  )
}
